// react
import React from 'react'
import { useState } from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import { ListView, NewEntityDialog } from '@st-operations/uikit/src/v2/index.js'
import Header from '_components/header/index.jsx'

// Styles
import './styles.scss'

import { ENTITY } from './constants'

// AppNexus Audiences Page
const AppNexusAudiences = () => {
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  return (
    <div id="appnexus-audiences-page" className="appnexus-audiences">
      <Header
        title="AppNexus Audiences"
        actions={[
          {
            children: 'Create New AppNexus Audience',
            onClick: toggleModal,
          },
        ]}
      />
      <ListView
        columns={[
          {
            name: 'Name',
            key: 'short_name',
          },
          {
            name: 'Id',
            key: 'id',
          },
          {
            name: 'Code',
            key: 'code',
          },
          {
            name: 'Member ID',
            key: 'member_id',
          },
          {
            name: 'Category',
            key: 'category',
          },
          {
            name: 'Last Modified',
            key: 'last_modified',
          },
        ]}
        entities={ENTITY}
        fields={['short_name', 'id', 'code', 'member_id', 'category', 'last_modified']}
        searchable={true}
        sort_dir={1}
        sort_key={'short_name'}
      />
      <If condition={modalOpen}>
        <Dialog close={toggleModal} open={modalOpen}>
          <NewEntityDialog close={toggleModal} entities={ENTITY} title="Please enter a name" />
        </Dialog>
      </If>
    </div>
  )
}

// export
export default AppNexusAudiences
